import getConfig from 'next/config';

import { isProdEnv } from './isProduction';
import { isServer } from './isServer';

/**
 * @returns Нужно для тестирования с продовыми данными на дев окружениях.
 * Возвращает урлы продовых сервисов если окружение витрины не равно проду.
 *
 * На дев окружениях мы можем ходить только через PUBLIC урл.
 */
export const getProdServicesForTesting = () => {
  const isTestWithProdDataAllowed = isServer
    ? process.env.ALLOW_TESTING_WITH_PROD_DATA
    : getConfig().publicRuntimeConfig.testWithProdData;

  if (!isProdEnv && isTestWithProdDataAllowed === 'true') {
    return {
      isTestingAllowed: true,
      microcreditsUrl: isServer
        ? `${process.env.PUBLIC}/v1/microCredit/list-ab/`
        : `${getConfig().publicRuntimeConfig.publicUrl}/v1/microCredit/list-ab/`,
    };
  }

  return {
    isTestingAllowed: false,
    microcreditsUrl: '',
  };
};
